<template>
	<div style="margin: 0 auto;">
		<div style="font-size: 30px; padding: 10px 0;">{{ $route.meta.title }}</div>
		<div style="padding:6px 15px; ">
			<Form ref="searchForm" :model="searchForm" label-position="right" :label-width="45" inline label-colon>
				<FormItem label="城市">
					<Cascader v-model="searchForm.region" :data="citys" change-on-select></Cascader>
				</FormItem>
				<FormItem label="名称"><Input type="text" v-model="searchForm.name" placeholder="名称" /></FormItem>
				<FormItem label="电话"><Input type="text" v-model="searchForm.telephone" placeholder="电话" /></FormItem>
				<FormItem label="地址"><Input type="text" v-model="searchForm.address" placeholder="地址" /></FormItem>
				<FormItem>
					<Button type="primary" @click="handleSubmit('searchForm')">
						<Icon type="ios-search" />
						搜索
					</Button>
				</FormItem>
			</Form>
		</div>
		<Table :data="tableData2" :columns="tableColumns2" size="large" border :loading="loading" header="header" footer="footer">
			<template slot-scope="{ row }" slot="worktime">
				<Tag color="success" v-for="(item,index) in row.worktimes" :key="index">{{item}}</Tag>
			</template>
			<template slot-scope="{ row }" slot="state">
				<Tag color="success" v-if="row.stateflag == '1'">启用</Tag>
				<Tag color="error" v-else>停用</Tag>
			</template>
			<template slot-scope="{ row }" slot="view">
				<Tag color="success" v-if="row.viewflag == '1'">显示</Tag>
				<Tag color="error" v-else>隐藏</Tag>
			</template>
			<template slot-scope="{ row }" slot="action">
				<Button @click="jczModify(row.id)" type="warning">
					修改
					<Icon type="ios-arrow-forward" />
				</Button>
			</template>
			<template slot-scope="{ row }" slot="action2">
				<router-link :to="{ path: 'view/' + row.id }">
					<Button type="primary">
						进入
						<Icon type="ios-arrow-forward" />
					</Button>
				</router-link>
			</template>

			<template slot="header">
				<div class="flex justify-between">
					<div span="12">
						<div class="padding-left">
							<Button type="success" @click="showJczAddModal=true" icon="ios-add">添加检测站</Button>
						</div>
					</div>
					<div span="12">
						<div style="text-align: right;">
							<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
							 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
						</div>
					</div>
				</div>

			</template>
			<template slot="footer">
				<div style="text-align: right;">
					<Page :total="searchForm.total" :page-size="searchForm.size" :current="searchForm.page" @on-change="pageChange"
					 :show-total="true" :show-sizer="true" @on-page-size-change="pageSizeChange"></Page>
				</div>
			</template>
		</Table>
		<Modal v-model="showJczAddModal" title="添加检测站" @on-ok="jczAddSubmit('formJczAdd')" :mask-closable="false" footer-hide>
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formJczAdd" :model="formJczAdd" label-position="right" :label-width="100" label-colon>
					<FormItem label="城市">
						<Cascader v-model="formJczAdd.region" :data="citys" change-on-select></Cascader>
					</FormItem>
					<Divider orientation="left">检测站信息</Divider>
					<FormItem label="名称">
						<Input v-model="formJczAdd.name" maxlength="18"></Input>
					</FormItem>
					<FormItem label="图片">
						<div class="demo-upload-list" v-for="item in uploadList">
							<template v-if="item.status === 'finished'">
								<img :src="item.url">
								<div class="demo-upload-list-cover">
									<Icon type="ios-eye-outline" @click.native="handleView(item.name)"></Icon>
									<Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
								</div>
							</template>
							<template v-else>
								<Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
							</template>
						</div>
						<Upload ref="upload" name="file" :show-upload-list="false" :on-success="handleSuccess" :format="['jpg','jpeg','png']"
						 :max-size="2048" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :before-upload="handleBeforeUpload"
						 multiple type="drag" action="https://cjb.xahulian.com/server/api/upload.php?a=upload" :data="{dir:'jcz'}" style="display: inline-block;">
							<div style="width: 58px;height:58px;line-height: 58px;" v-if="uploadList.length<5">
								<Icon type="ios-camera" size="20"></Icon>
							</div>
						</Upload>
					</FormItem>
					<FormItem label="服务费">
						<Input v-model="formJczAdd.fuwufei" maxlength="6" style="width: 120px;"></Input> 元<span class="text-sm text-orange">（未填写则按订单设置中价格）</span>
					</FormItem>
					<FormItem label="检测费">
						<Input v-model="formJczAdd.jcf" maxlength="6" style="width: 120px;"></Input> 元
					</FormItem>
					<FormItem label="电话">
						<Input v-model="formJczAdd.telephone" maxlength="18"></Input>
					</FormItem>
					<FormItem label="地址">
						<Input v-model="formJczAdd.address" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
					</FormItem>
					<FormItem label="上班时间">
						<div>
							<TimePicker v-model="formJczAdd.worktime[0]" type="timerange" :steps="[1,15]" confirm format="HH:mm"
							 hide-disabled-options :disabled-hours="[0,1,2,3,4,5,6,20,21,22,23]" placeholder="Select time" style="width: 168px"></TimePicker>
						</div>
						<div class="padding-top">
							<TimePicker v-model="formJczAdd.worktime[1]" type="timerange" :steps="[1,15]" confirm format="HH:mm"
							 hide-disabled-options :disabled-hours="[0,1,2,3,4,5,6,20,21,22,23]" placeholder="Select time" style="width: 168px"></TimePicker>
						</div>
						<div class="padding-top-xs">
							如果全天不休，只填写一个时间。
						</div>
					</FormItem>
					<FormItem label="启用状态">
						<i-switch v-model="formJczAdd.stateflag" :true-value="1" :false-value="0">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					<FormItem label="前端显示">
						<i-switch v-model="formJczAdd.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="备注">
						<Input v-model="formJczAdd.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="jczAddSubmit('formJczAdd')" :loading="jczAddLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="showJczAddModal=false">取消</Button>
					</FormItem>
				</Form>
			</div>
		</Modal>
		<Modal v-model="showJczModifyModal" title="修改检测站信息" @on-ok="jczModifySubmit('formJczModify')" :mask-closable="false"
		 footer-hide>
			<div style="position: relative;" class="padding-left padding-right-xl">
				<Form ref="formJczModify" :model="formJczModify" label-position="right" :label-width="100" label-colon>
					<FormItem label="城市">
						<Cascader v-model="formJczModify.region" :data="citys" change-on-select></Cascader>
					</FormItem>
					<Divider orientation="left">检测站信息</Divider>
					<FormItem label="名称">
						<Input v-model="formJczModify.name" maxlength="18"></Input>
					</FormItem>
					<FormItem label="服务费">
						<Input v-model="formJczModify.fuwufei" maxlength="6" style="width: 120px;"></Input> 元<span class="text-sm text-orange">（未填写则按订单设置中价格）</span>
					</FormItem>
					<FormItem label="检测费">
						<Input v-model="formJczModify.jcf" maxlength="6" style="width: 120px;"></Input> 元
					</FormItem>
					<FormItem label="电话">
						<Input v-model="formJczModify.telephone" maxlength="18"></Input>
					</FormItem>
					<FormItem label="地址">
						<Input v-model="formJczModify.address" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
					</FormItem>
					<FormItem label="上班时间">
						<div>
							<TimePicker v-model="formJczModify.worktime[0]" type="timerange" :steps="[1,15]" confirm format="HH:mm"
							 hide-disabled-options :disabled-hours="[0,1,2,3,4,5,6,20,21,22,23]" placeholder="Select time" style="width: 168px"></TimePicker>
						</div>
						<div class="padding-top">
							<TimePicker v-model="formJczModify.worktime[1]" type="timerange" :steps="[1,15]" confirm format="HH:mm"
							 hide-disabled-options :disabled-hours="[0,1,2,3,4,5,6,20,21,22,23]" placeholder="Select time" style="width: 168px"></TimePicker>
						</div>
						<div class="padding-top-xs">
							如果全天不休，只填写一个时间。
						</div>
					</FormItem>
					<FormItem label="启用状态">
						<i-switch v-model="formJczModify.stateflag" :true-value="1" :false-value="0">
							<span slot="open">是</span>
							<span slot="close">否</span>
						</i-switch>
					</FormItem>
					<FormItem label="前端显示">
						<i-switch v-model="formJczModify.viewflag" :true-value="1" :false-value="0">
							<span slot="open">显示</span>
							<span slot="close">隐藏</span>
						</i-switch>
					</FormItem>
					<FormItem label="备注">
						<Input v-model="formJczModify.remark" type="textarea" :autosize="{minRows: 2,maxRows: 5}"></Input>
					</FormItem>
					<Divider />
					<FormItem>
						<Button type="primary" @click="jczModifySubmit('formJczModify')" :loading="jczModifyLoading" icon="ios-add">提交</Button>
						<Button style="margin-left: 8px" @click="showJczModifyModal=false">取消</Button>
					</FormItem>
				</Form>
				<Spin size="large" fix v-if="jczModifyLoading"></Spin>
			</div>
		</Modal>
		<Modal title="View Image" v-model="viewImg">
			<img :src="'https://o5wwk8baw.qnssl.com/' + imgName + '/large'" v-if="viewImg" style="width: 100%">
		</Modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				jczList: [],
				state_arr: [],
				viewImg: false,
				uploadList: [],
				showJczAddModal: false,
				jczAddLoading: false,
				formJczAdd: {
					region: ['陕西省', '西安市'],
					name: "",
					jcf:0,
					telephone: "",
					address: "",
					worktime: [],
					pics: [],
					stateflag:1,
					viewflag:1,
					remark: ""
				},
				showJczModifyModal: false,
				jczModifyLoading: false,
				formJczModify: {
					region: ['陕西省', '西安市'],
					name: "",
					jcf:0,
					telephone: "",
					address: "",
					worktime: [],
					stateflag:1,
					viewflag:1,
					remark: ""
				},
				loading: false,
				tableColumns2: [{
						title: 'id',
						type: 'index',
						align:'center',
						width: 58
					},
					{
						title: '城市',
						key: 'region',
						align: 'center',
						width:150
					},
					{
						title: '名称',
						key: 'name'
					},
					{
						title: '电话',
						align: 'center',
						key: 'telephone',
						width:150
					},
					{
						title: '工作时间',
						key: 'worktime',
						slot: 'worktime',
						width:120
					},
					{
						title: '服务费',
						align: 'center',
						key: 'fuwufei',
						width:110
					},
					{
						title: '检测费',
						align: 'center',
						key: 'jcf',
						width:110
					},
					{
						title: '启用状态',
						align: 'center',
						slot: 'state',
						width:110
					},
					{
						title: '前端显示',
						align: 'center',
						slot: 'view',
						width:110
					},
					{
						title: '服务师傅',
						align: 'center',
						key: 'sf',
						width:110
					},
					{
						title: '订单数',
						align: 'center',
						key: 'order',
						width:110
					},
					{
						title: '添加时间',
						align: 'center',
						key: 'addtime',
						width:190
					},
					{
						title: '操作',
						slot: 'action',
						width:130
					}
				],
				tableData2: [],
				searchForm: {
					page: 1,
					size: 20,
					total: 0,
					region: ['陕西省', '西安市'],
					name: '',
					telephone: '',
					address: ''
				},
				citys: [{
					value: '陕西省',
					label: '陕西省',
					children: [{
							value: '西安市',
							label: '西安市'
						},
						{
							value: '铜川市',
							label: '铜川市'
						},
						{
							value: '宝鸡市',
							label: '宝鸡市'
						},
						{
							value: '咸阳市',
							label: '咸阳市'
						},
						{
							value: '渭南市',
							label: '渭南市'
						},
						{
							value: '延安市',
							label: '延安市'
						},
						{
							value: '汉中市',
							label: '汉中市'
						},
						{
							value: '榆林市',
							label: '榆林市'
						},
						{
							value: '安康市',
							label: '安康市'
						},
						{
							value: '商洛市',
							label: '商洛市'
						},
						{
							value: '其他',
							label: '其他'
						}
					]
				}]
			};
		},
		methods: {
			handleSubmit(name) {
				this.loadinfos();
				return false;
			},
			loadinfos() {
				var that = this;
				this.loading = true;
				this.$http.post('/server/api/public/jcz.php?a=list', this.$qs.stringify(this.searchForm)).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							this.searchForm.total = res.data.data.total;
							this.tableData2 = res.data.data.infos;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			handleRemove(file) {
				const fileList = this.$refs.upload.fileList;
				this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
				this.formJczAdd.pics.splice(fileList.indexOf(file), 1);
			},
			handleSuccess(res, file, fileList) {
				//this.uploadList.push({"url":"http://cjb.xahulian.com/"+res.data.url})
				file.url = "http://cjb.xahulian.com/" + res.data.url;
				this.formJczAdd.pics.push(res.data.url);
			},
			handleFormatError(file) {
				this.$Notice.warning({
					title: 'The file format is incorrect',
					desc: 'File format of ' + file.name + ' is incorrect, please select jpg or png.'
				});
			},
			handleMaxSize(file) {
				this.$Notice.warning({
					title: 'Exceeding file size limit',
					desc: 'File  ' + file.name + ' is too large, no more than 2M.'
				});
			},
			handleBeforeUpload() {
				const check = this.uploadList.length < 5;
				if (!check) {
					this.$Message.warning({
						background: true,
						content: "最多只能上传5张图片。",
					});
				}
				return check;
			},
			pageChange(page) {
				this.searchForm.page = page;
				this.loadinfos();
			},
			pageSizeChange(size) {
				this.searchForm.size = size;
				this.loadinfos();
			},
			jc_date(date) {
				this.formJczAdd.date = date;
			},
			register_date(date) {
				this.formJczAdd.carinfo.register_date = date;
			},
			jczAddSubmit(name) {
				this.jczAddLoading = true;
				if (!this.formJczAdd.region[1]) {
					this.$Message.error({
						background: true,
						content: "填选择城市",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczAdd.name) {
					this.$Message.error({
						background: true,
						content: "请填写名称",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczAdd.telephone) {
					this.$Message.error({
						background: true,
						content: "请填写电话",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczAdd.address) {
					this.$Message.error({
						background: true,
						content: "请填写地址",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczAdd.worktime[0] && !this.formJczAdd.worktime[1]) {
					this.$Message.error({
						background: true,
						content: "请填写工作时间",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				this.$http.post('/server/api/public/jcz.php?a=add', this.$qs.stringify(this.formJczAdd)).then(
					res => {
						this.jczAddLoading = false;
						if (res.data.result == 'ok') {
							this.$Message.success({
								background: true,
								content: "添加成功!",
								onClose: () => {
									this.showJczAddModal = false;
									this.loadinfos();
									//this.$router.push("/public/jcz/view/" + res.data.data.id);
								}
							});
						} else {
							this.$Modal.error({
								title: '添加失败',
								content: res.data.msg
							});
						}
					},
					r => {
						this.jczAddLoading = false;
						this.$Message.error('系统错误');
					}
				);
				return false;
			},
			jczModify(id) {
				this.showJczModifyModal = true;
				this.jczModifyLoading = true;
				this.$http.post('/server/api/public/jcz.php?a=getinfo', this.$qs.stringify({
					id: id
				})).then(
					res => {
						this.loading = false;
						if (res.data.result == 'ok') {
							//this.$Message.success('获取成功!');
							//this.citys=res.data.data.citys;
							this.jczModifyLoading = false;

							this.formJczModify = res.data.data.info;
						} else {
							this.$Message.error(res.data.msg);
						}
					},
					r => {
						this.loading = false;
						this.$Message.error('系统错误');
					}
				);
			},
			jczModifySubmit(name) {
				this.jczModifyLoading = true;
				if (!this.formJczModify.region[1]) {
					this.$Message.error({
						background: true,
						content: "填选择城市",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczModify.name) {
					this.$Message.error({
						background: true,
						content: "请填写名称",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczModify.telephone) {
					this.$Message.error({
						background: true,
						content: "请填写电话",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczModify.address) {
					this.$Message.error({
						background: true,
						content: "请填写地址",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				if (!this.formJczModify.worktime[0] && !this.formJczModify.worktime[1]) {
					this.$Message.error({
						background: true,
						content: "请填写工作时间",
						onClose: () => {
							this.jczAddLoading = false;
						}
					});
					return false;
				}
				this.$http.post('/server/api/public/jcz.php?a=modify', this.$qs.stringify(this.formJczModify)).then(
					res => {
						this.jczModifyLoading = false;
						if (res.data.result == 'ok') {
							this.$Message.success({
								background: true,
								content: "修改成功!",
								onClose: () => {
									this.showJczModifyModal = false;
									this.loadinfos();
									//this.$router.push("/public/jcz/view/" + res.data.data.id);
								}
							});
						} else {
							this.$Modal.error({
								title: '操作失败',
								content: res.data.msg
							});
						}
					},
					r => {
						this.jczAddLoading = false;
						this.$Message.error('系统错误');
					}
				);
				return false;
			}
		},
		mounted() {
			this.uploadList = this.$refs.upload.fileList;
		},
		created() {
			//console.log(this.searchForm)
			this.loading = true;
			this.$http.post('/server/api/public/jcz.php?a=init').then(
				res => {
					this.loading = false;
					if (res.data.result == 'ok') {
						//this.$Message.success('获取成功!');
						this.citys=res.data.data.citys;
						this.loadinfos();
					} else {
						this.$Message.error(res.data.msg);
					}
				},
				r => {
					this.loading = false;
					this.$Message.error('系统错误');
				}
			);
		}
	};
</script>

<style>
	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
		display: block;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
